import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Route from "./route/index";
import Header from "@view/header/Header";
import { Provider, rootStore } from "@store/Route";

function App() {
  const basename = "/";

  if (process.env.REACT_APP_STATUS === "STAGING") {
    console.log = function () {};
  }

  return (
    <Provider value={rootStore}>
      <BrowserRouter basename={basename}>
        <Header />
        <Route />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
